import { Box } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { CollectionItemDownloadContainer } from '~/components/collection/CollectionItemDownloadContainer';
import { PreviewDigitalContent } from '~/components/collection/PreviewDigitalContent';
import { apiClient } from '~/lib/apiClient';
import { RootContext } from '~/store';
import { GachaDetail } from '~/types/resources/gachaDetail';
import type { GrantedPrize } from '~/types/resources/grantedPrize';

type Props = {
  grantedPrize: GrantedPrize;
  isDownloadable?: boolean;
  gachaDownloadSetting: GachaDetail['content_download'];
};

export const PreviewPrizeDigitalContentContainer: React.FC<Props> = (
  props: Props
) => {
  const { token } = useContext(RootContext);
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  const resetDownloadUrl = async () => {
    const res = await apiClient.v1.me.granted_prizes.prizes
      ._prizeId(props.grantedPrize.prize.id)
      .download.$get({
        headers: {
          Authorization: `Bearer ${token?.token}`,
        },
      });

    return res.signed_url;
  };

  useEffect(() => {
    const handleReset = async () => {
      const url = await resetDownloadUrl();
      setDownloadUrl(url);
    };
    if (downloadUrl == null) {
      handleReset();
    }
  }, [downloadUrl]);

  return (
    <>
      <PreviewDigitalContent
        downloadUrl={downloadUrl}
        filename={props.grantedPrize.prize.name}
        isDownloadable={props.isDownloadable}
      />
      <Box h={4} />
      <CollectionItemDownloadContainer
        contentUrl={downloadUrl ?? undefined}
        contentDownloadSetting={props.gachaDownloadSetting}
      />
    </>
  );
};
